import { types } from "../actions/ownerEMOChecklist";

const initialState = {
    theminimumqualifications: null,
    theapplicantRegistered: null,
    theApplicantPossess: null,
    thelicenseMembership:null,
    theApplicantGraduate:null,
    theapplicantMember:null,
    theApplicantHold:null,
    theApplicantQualifications:null,
    theApplicantFiveYears:null,
    theApplicantTwoYears:null,
    theApplicantOneYears:null,
    theApplicantPossessValid:null,
    theApplicantAssociateMembership:null,
    theApplicantITPI:null,
    theApplicantITPImembership:null,
    theLandscapeArchitecture:null,
    theDegreeUrbanDesign:null,
};

export const checklistLTPReducer = (state = initialState, action) => {
    switch (action?.type) {
        case types.UPDATE_CHECKLIST_FORM_FIELD:
            const newState = {
                ...state,
                [action.payload.name]: action.payload.value,
            };
            sessionStorage.setItem("ltpCheckList", JSON.stringify(newState));
            return newState
        default:
            return state;
    }
};